export default __webpack_public_path__ + "static/media/info-concierge.inline.4d895786.svg";